import { useTranslation } from 'react-i18next'
import Icon from '@/components/ui/icon'

const BRIEFING_IMAGE =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAGB8po8Q9uP1nDRFWjJrcMNVpsJC-dD0WXAna8T6XwISGb7XDHVN40x72iOFNU2084O0NHPm4sN1dJzvJqtrFQStC6XsRhSBXFJfF1sEBVA4a9DzO0tm6O8PeUgJZhq7a9BejkCWXh5152dt0ereK5cXXyzdgRLyKQbs3vIJUJ1hiOn0SJh2PMXm9j5U3LkryL1_gnH3aIK_IAY5KRVM6VnVQYCKwbCuJr8Tc_6V9DN-S_sA1qoRdNhOMkoGNqL0G4sye_ncwaSCKa'

export default function Briefings() {
  const { t } = useTranslation()

  return (
    <section className="px-5 sm:px-8 md:px-10 lg:px-12 max-w-[1440px] mx-auto mb-16 md:mb-32 lg:mb-48">
      <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-4 mb-8 md:mb-12">
        <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tighter text-on-surface">
          {t('manifesto.briefings.title')}
        </h2>
        <a
          className="text-primary text-xs font-bold tracking-widest uppercase border-b border-primary hover:text-on-surface hover:border-on-surface transition-all"
          href="#"
        >
          {t('manifesto.briefings.viewAll')}
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 h-auto md:h-[600px]">
        {/* Large featured card - spans 2 cols and 2 rows */}
        <div className="md:col-span-2 md:row-span-2 bg-surface-container-low group overflow-hidden relative">
          <img
            alt="Grid de cibersegurança"
            className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:scale-105 transition-transform duration-700"
            src={BRIEFING_IMAGE}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-surface-container-lowest to-transparent p-6 md:p-10 flex flex-col justify-end">
            <span className="text-primary text-[10px] uppercase tracking-[0.3em] mb-2">
              {t('manifesto.briefings.featured.category')}
            </span>
            <h3 className="text-on-surface font-display text-3xl font-bold leading-none mb-4">
              {t('manifesto.briefings.featured.title')}
            </h3>
            <button className="flex items-center text-xs text-white/50 group-hover:text-primary transition-colors cursor-pointer">
              {t('manifesto.briefings.featured.link')}{' '}
              <Icon name="arrow_forward" className="text-sm ml-2" />
            </button>
          </div>
        </div>

        {/* Top right card - spans 2 cols */}
        <div className="md:col-span-2 bg-surface-container-high p-6 md:p-10 flex flex-col justify-between border-b-2 border-primary/20">
          <div>
            <span className="text-primary text-[10px] uppercase tracking-[0.3em] mb-2 block">
              {t('manifesto.briefings.internal.category')}
            </span>
            <h3 className="text-on-surface font-display text-2xl font-bold">
              {t('manifesto.briefings.internal.title')}
            </h3>
          </div>
          <p className="text-on-surface-variant text-sm max-w-md">
            {t('manifesto.briefings.internal.description')}
          </p>
        </div>

        {/* Bottom right - case card */}
        <div className="bg-surface-container-low p-5 md:p-8 md:border-r border-outline-variant/10">
          <span className="text-on-surface-variant text-[10px] uppercase tracking-widest mb-4 block">
            {t('manifesto.briefings.case.label')}
          </span>
          <h3 className="text-on-surface font-display font-bold text-lg mb-4">
            {t('manifesto.briefings.case.title')}
          </h3>
          <p className="text-xs text-on-surface-variant">
            {t('manifesto.briefings.case.description')}
          </p>
        </div>

        {/* Bottom right - event card (primary bg) */}
        <div className="bg-primary-container p-5 md:p-8 flex flex-col justify-between">
          <span className="text-on-primary text-[10px] uppercase tracking-widest mb-4 block">
            {t('manifesto.briefings.event.label')}
          </span>
          <h3 className="text-on-primary font-display font-bold text-lg mb-4">
            {t('manifesto.briefings.event.title')}
          </h3>
          <Icon name="location_city" className="text-on-primary text-4xl" />
        </div>
      </div>
    </section>
  )
}
